import UserAvatar from '../../../../components/global/data-display/UserAvatar';
import { Row, Text } from '@ydistri/ds';
import React from 'react';
import { Popover } from 'antd';

interface CalculationOwnerProps {
  fullName: string;
  avatarOnly?: boolean;
}

/**
 * Displays an avatar and the fullName next to each other
 */
const CalculationOwner: React.FC<CalculationOwnerProps> = ({ fullName, avatarOnly = false }) => {
  if (avatarOnly) {
    return (
      <Row $gap="0.5rem" $alignItems="center">
        <Popover title={fullName} trigger="hover">
          <UserAvatar fullName={fullName} />
        </Popover>
      </Row>
    );
  }

  return (
    <Row $gap="0.5rem" $alignItems="center">
      <UserAvatar fullName={fullName} />
      <Text data-type="CalculationOwner" $size="large">
        {fullName}
      </Text>
    </Row>
  );
};

export default React.memo(CalculationOwner);
